export default "/images/Opportunity5.png?778250f51090ca8a0e24a9721191ad87";